import {axi, GetListOutput, GetListParams} from '@shared/api';
import {validateData} from '@shared/utils';
import {KycRecord} from '../types';
import {v8nSchemaOfGetKycResponse} from './backendSchemas';
import {GetKycResponse} from './backendTypes';
import {mapKycRecordFromBackend} from './dataMappers';

export type GetKycParams = GetListParams;

export const getKyc = async ({page, pageSize}: GetKycParams = {}): Promise<
  GetListOutput<KycRecord>
> => {
  const response = await axi.get<GetKycResponse>('/admin/kyc', {
    params: {
      page,
      per_page: pageSize,
    },
  });

  validateData(response.data, v8nSchemaOfGetKycResponse, 'getKyc');

  const {
    total,
    total_pages,
    array,
    page: pageFromBackend,
    per_page: pageSizeFromBackend,
  } = response.data;

  return {
    page: pageFromBackend,
    pageSize: pageSizeFromBackend,
    total,
    totalPages: total_pages,
    items: array.map(item => mapKycRecordFromBackend(item)),
  };
};
